import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { RateAgreement } from "../RateAgreement";
import { updateSuccessMessage } from "../../../Messages/successMessages";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useUpdateRateAgreement = (rateAgreementId: number | string | undefined) => {
  return useMutation({
    mutationFn: async (rateAgreement: RateAgreement) => {
      await axios.put(rateAgreementUrls.base.apiUrl, rateAgreement);
    },
    onSuccess: async () => toast.success(updateSuccessMessage(rateAgreementId, "Rate Agreement")),
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
